// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__W_mFW","gfeWrapper":"CalendarEvent_gfeWrapper__JHkE3"};